import { atom } from 'jotai';

const query = atom({
    key: 'queryState',
    default: ''
});

export default query;
